import { put, call, takeLatest } from "redux-saga/effects";
import { actions } from "./Reducer";
import {push} from "connected-react-router"
import {
  getSupplierTagsSuccessAction,
  setSupplierTagsIsLoadingAction,
  createSupplierTagSuccessAction,
  updateSupplierTagSuccessAction,
  setSupplierTagsCountAction
} from "./Actions";

import {
  errorNotificationFromError,
  newSuccessNotificationAction
} from "../notifications/Actions";

import * as api from "./Api";

function* createSupplierTag({ payload }) {
  try {
    yield put(setSupplierTagsIsLoadingAction(true));
    const response = yield call(api.createSupplierTag, payload);
    const { data } = response;
    const tag = data;
    yield put(createSupplierTagSuccessAction(tag));
    yield put(newSuccessNotificationAction(`Created Tag : ${tag.name}`))

    yield put(push('/supplier-tags'))
      

  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierTagsIsLoadingAction(false));
  }
}

function* updateSupplierTag({ payload: { id, formData } }) {
  try {
    yield put(setSupplierTagsIsLoadingAction(true));
    const response = yield call(api.updateSupplierTag, id, formData);
    const { data } = response;
    const updatedTag = data;
    yield put(updateSupplierTagSuccessAction(updatedTag));
    yield put(
      newSuccessNotificationAction(`Updated Tag : ${updatedTag.name}`)
    );

    yield put(push('/supplier-tags'));

  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierTagsIsLoadingAction(false));
  }
}

function* getSupplierTags({payload}) {
  
  const defData = {
    "offset": 0,
    "size": 10,
    "searchTerm": "",
    "sort": "name",
    "dir": "asc"
  }
  const body = {...defData , ...payload}
  try {
    yield put(setSupplierTagsIsLoadingAction(true));
    const response = yield call(api.getSupplierTags , body);
    const {data} = response

    const count = data.count
    const supplierTags = data.content;

    yield put(setSupplierTagsCountAction(count))
    yield put(getSupplierTagsSuccessAction(supplierTags));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierTagsIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.GET_SUPPLIER_TAGS, getSupplierTags);
  yield takeLatest(actions.CREATE_SUPPLIER_TAG, createSupplierTag);
  yield takeLatest(actions.UPDATE_SUPPLIER_TAG, updateSupplierTag);
}
